import type { Component, Entity2D } from '../../odie';
import { BathtubBlockProps, CountBlockOptionDef } from '../defs/block';
import { BathtubBlockView } from '../views/blocks/BathtubBlockView';

export type BathtubBlockComponentOptions = {
  props: BathtubBlockProps;
  option?: number;
};

export class BathtubBlockComponent implements Component {
  public static readonly NAME = 'blockBathtub';
  public entity!: Entity2D;
  public view!: BathtubBlockView;
  private props!: BathtubBlockProps;

  public init(options: BathtubBlockComponentOptions): void {
    const optionDef = options.props.options?.[
      options.option || 0
    ] as CountBlockOptionDef;

    this.props = options.props;
    this.view = new BathtubBlockView(options.props);
    this.count = optionDef.count;

    // Set the getGameplayState retrieval function
    this.entity.c.block.getGameplayState = () => this.getGameplayState();
  }

  public get count(): number {
    return this.view.count;
  }

  public set count(value: number) {
    this.view.count = value;
  }

  public getGameplayState(): number {
    const options = this.props.options as CountBlockOptionDef[];
    return options.findIndex((opt) => {
      return opt.count === this.view.count;
    });
  }
}
